import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import {
	autoEuropeProviderNormalizationIsSubmitting,
	clearAutoEuropeProviderNormalizationSignals,
} from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

const PROVIDER_NORMALIZATION_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/provider-normalization`

const extractId = o => (typeof o === 'object' && o !== null) ? o.value : o

const transformData = (data) => ({
	normalization_record_id: data.normalizationRecordId,
	provider: extractId(data.provider),
	autoEuropeProvider: data.autoEuropeProvider,
	office_countries: data.filterMode === 'officeCountry' ? (data.officeCountries ?? []).map(extractId) : [],
	offices: data.filterMode === 'office' ? (data.offices ?? []).map(extractId) : [],
})

export default function useAutoEuropeProviderNormalizationFormSubmit({ getTableData }) {
	const { showToast } = useToast()

	const onSubmit = useCallback((data) => {
		autoEuropeProviderNormalizationIsSubmitting.value = true
		const isEditing = !!data._isEditing
		const endpoint = isEditing ? 'edit' : 'create'

		postSubmit(`${PROVIDER_NORMALIZATION_API}/${endpoint}`, transformData(data))
			.then(() => {
				autoEuropeProviderNormalizationIsSubmitting.value = false
				getTableData()
				clearAutoEuropeProviderNormalizationSignals()
				showToast.success(isEditing ? "Provider Normalization updated" : "Provider Normalization created")
			})
			.catch(async (e) => {
				autoEuropeProviderNormalizationIsSubmitting.value = false
				if (e?.status === 409) {
					const body = await e.json().catch(() => ({}))
					showToast.error(body?.error_msg || "Provider Normalization already exists", { autoClose: 20000 })
				} else {
					showToast.error("Error saving Provider Normalization record", { autoClose: 20000 })
				}
			})
	}, [getTableData])

	return { onSubmit }
}
